import { Reducer } from 'redux';
import { DashboardState, DashboardActionTypes } from 'types';

const initialState: DashboardState = {
  uiSelectionState: {
    rangeText: '',
    showShape: true,
    showPoint: false,
    showGrid: false,
    adminRangeText: ''
  }
};

const reducer: Reducer<DashboardState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_START: {
      return {
        ...state,
        enquirerStats: undefined
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_SUCCESS: {
      return {
        ...state,
        enquirerStats: action.payload
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_FAILURE: {
      return {
        ...state,
        enquirerStats: action.payload
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_START: {
      return {
        ...state,
        assetOwnerStats: undefined
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_SUCCESS: {
      return {
        ...state,
        assetOwnerStats: action.payload
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_FAILURE: {
      return {
        ...state,
        assetOwnerStats: action.payload
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_START: {
      return {
        ...state,
        dbydStats: undefined
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_SUCCESS: {
      return {
        ...state,
        dbydStats: action.payload
      };
    }
    case DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_FAILURE: {
      return {
        ...state,
        dbydStats: action.payload
      };
    }
    case DashboardActionTypes.RESET_DASHBOARD_STATE: {
      return {
        ...initialState,
        uiSelectionState: state.uiSelectionState
      };
    }
    case DashboardActionTypes.SET_DASHBOARD_UI_STATE_RANGE_TEXT: {
      return {
        ...state,
        uiSelectionState: {
          ...state.uiSelectionState,
          rangeText: action.payload
        }
      };
    }
    case DashboardActionTypes.SET_DASHBOARD_UI_STATE_SHOW_GRID: {
      return {
        ...state,
        uiSelectionState: {
          ...state.uiSelectionState,
          showGrid: action.payload
        }
      };
    }
    case DashboardActionTypes.SET_DASHBOARD_UI_STATE_SHOW_POINT: {
      return {
        ...state,
        uiSelectionState: {
          ...state.uiSelectionState,
          showPoint: action.payload,
          showShape: !action.payload
        }
      };
    }
    case DashboardActionTypes.SET_DASHBOARD_UI_STATE_SHOW_SHAPE: {
      return {
        ...state,
        uiSelectionState: {
          ...state.uiSelectionState,
          showShape: action.payload,
          showPoint: !action.payload
        }
      };
    }
    case DashboardActionTypes.SET_DASHBOARD_UI_STATE_ADMIN_RANGE_TEXT: {
      return {
        ...state,
        uiSelectionState: {
          ...state.uiSelectionState,
          adminRangeText: action.payload
        }
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as DashboardReducer };
